<template>
    <v-group>
        <BrushWithColor v-if="displayBrushWithColor"
                        :colorId="currentPaint.id"
                        :color="currentPaint.color"
                        :image="brushImage"
                        @getCachedImage="applyCachedBrushImage"
        ></BrushWithColor>

        <v-group v-if="displayPaintBrushStroke">
            <v-group v-for="paintPart in paintParts" :key="paintPart[0].id">
                <PaintBrushStroke
                        :brushImage="brushCachedImage"
                        :paintLineStrokePoints="getPaintLineStrokePoints(paintPart)"
                        :paintEnabled="paintPart[0]['paintEnabled']"
                        @togglePaintEnabled="togglePaintEnabled(paintPart[0])"
                ></PaintBrushStroke>
            </v-group>
        </v-group>
    </v-group>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import BrushWithColor from "./BrushWithColor";
    import PaintBrushStroke from "./PaintBrushStroke";

    export default {
        name: "TrimPaint",

        components: {
            PaintBrushStroke,
            BrushWithColor,
        },

        props: [
            'points',
        ],

        data() {
            return {
                brushImage: null,
                brushCachedImage: null,
                brushImageSrc: '/imgs/brushes/Brush-2.png',
            }
        },

        computed: {
            ...mapState('paint', [
                'currentPaint',
            ]),

            ...mapGetters('paint', [
                'getPaintParts',
                'getPaintLineStrokePoints',
            ]),

            paintParts() {
                return this.getPaintParts(this.points);
            },

            displayBrushWithColor() {
                return !!this.brushImage;
            },

            displayPaintBrushStroke() {
                return this.brushCachedImage && this.paintParts[0];
            },

        },

        methods: {
            ...mapMutations('paint', [
                'setPaintEnabled',
            ]),

            applyCachedBrushImage(image) {
                this.brushCachedImage = image;
            },

            togglePaintEnabled(startPoint) {
                let paintEnabled = !startPoint['paintEnabled'];

                this.setPaintEnabled({ point: startPoint, enabled: paintEnabled });
            },

        },

        beforeMount() {
            this.$utils.loadImage((image) => {
                this.brushImage = image;
            }, this.brushImageSrc);

        },

    }
</script>